export default "__VITE_ASSET__VOuq_Wvr__"